const ProductDetailsBanner = () => {
    return (
        <section>
            <div className="about_banner_wepper">
                <img src="images/about-banner.png" alt="" />
                <div className="about_content">
                    <h2> Product Details </h2>
                </div>
            </div>
        </section>
    )
}

export default ProductDetailsBanner;